import { render, staticRenderFns } from "./IncludedMgRoyalty.vue?vue&type=template&id=a439b1f4"
import script from "./IncludedMgRoyalty.vue?vue&type=script&lang=js"
export * from "./IncludedMgRoyalty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports